import { FAQ, FAQPageSection } from "../../models/page-builder/faq-section.model";
import { UploadedMedia } from "../../models/page-builder/uploaded-media.model";

const faqs: FAQ[] = [
  {
    question: "Way better than you might think",
    questionColor: "black",
    answer: "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",
    answerColor: "#475467",
    open: false
  },
  {
    question: "Can I change my plan later?",
    questionColor: "black",
    answer: "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",
    answerColor: "#475467",
    open: false

  },
  {
    question: "What is your cancellation policy?",
    questionColor: "black",
    answer: "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",
    answerColor: "black",
    open: false

  },
  {
    question: "Text and supporting text",
    questionColor: "black",
    answer: "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",
    answerColor: "black",
    open: true
  },

];

const image: UploadedMedia = {
  type: "image",
  originalFileName: "b3d",
  uploadFileName: "3d",
  url: "https://firebasestorage.googleapis.com/v0/b/chidume-local-dev.appspot.com/o/QqPcvz32KBXeg10On5kZNSwy0WD2%2FpageBuilder%2F1%2FVector.png?alt=media&token=4d2e4523-c709-4c00-9059-1ba1c8ca4314",
  imageSettings: {
    overlayWithBackground: true,
    opacity: 0.1,
    blending: "normal",
    blur: 2,
    grayScale: 10,
    contrast: 100,
  },
}

export const MOCK_PAGE_FAQ_SECTION: FAQPageSection = {
  type: "faq",
  content: {
    header: {
      title: "Frequently asked questions",
      titleColor: "#000000",
      subtitle:
        "Everything you need to know about the product and billing.",
      subTitleColor: "#000000",
    },
    questions: {
      faqs
    },
    images: {
      listIcon: {
        enabled: true,
        svgName: "optionIcon-1",
        color: "red",
      },
    }
  },
  design: {
    layout: {
      blockStyle: "card",
      headingAlignment: "center"
    },
    appearance: {
      backgroundImage: null,//image,
      cardBackgroundColor: "grey",
      backgroundColor: "white"
    }
  }

}
